<div class="pie-chart__wrapper">
    <h3 *ngIf="name" class="chart-header">{{name}}</h3>
    <div class="chart"></div>
</div>